<template>
<div >
    <v-toolbar flat color="white">
        <v-btn id="locationTypeAddButtonId" color="primary" dark class="mb-2" @click="newDialog=true" round >ADD TYPE</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        id="searchId"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>

     <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">

        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD TYPE</h1>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    id="locationTypeAddNameId"
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="Name*"
                    hint="What would you like to call this type"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.code"
                    label="Code"
                  ></v-text-field>
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn id="locationTypeSaveAddButtonId" color="blue darken-1" flat @click="saveNew">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Edit Modal -------------------------------------------------------------------------------------------->
    <v-dialog persistent v-model="dialog" max-width="750px">
      <v-card>
        
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT TYPE</h1>
        </v-toolbar>
          
           <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
            
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    id="locationTypeEditNameId"
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="Name*"
                    hint="What would you like to call this type"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.code"
                    label="Code"
                  ></v-text-field>
                </v-flex>
     
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn id="locationTypeSaveEditButtonId" color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="locationTypes"
      :rows-per-page-items="[10, 25, 50, 100]"
      item-key="name" 
      align-center
    >
      <template v-slot:items="props" >
        <td class="justify-center layout px-0">
            <v-icon id="locationTypeEditButtonId" small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon id="locationTypeDeleteButtonId" small @click="deleteItem(props.item.id)">delete</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td class="text-xs-center">{{props.item.code}}</td>
          <!-- <td class="text-xs-center">{{props.item.locationTypeCat.name}}</td> -->
          <td class="text-xs-center" v-if="props.item.isActive">
          <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
          </td>
          
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->

    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
export default {
  data() {
    return {
    showDetails: true,
    isloading:true,
    loading: false, 
    expand: false,
    search: "",
    dialog: false,
    newDialog: false,
    pagination: { },
    headers: [
            {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Code",
        align: "center",
        value: "code"
      },
      // {
      //     text: "Location Type Category",
      //     align: "center",
      //     value: "locationTypeCat"
      // },
      {
        text: "Active",
        align: "center",
        value: "isActive"
      }
    ],
    locationTypeCat: [],
    locationTypes: [], 
    editedIndex: -1,
    editedItem: {
        name: "",
        code: "",
        locationTypeCat:"",
        locationTypeCatId: "",         
        isActive: true,
        isDeleted: false
    },
    defaultItem: {
        name: "",
        code: "",
        locationTypeCat:"",
        locationTypeCatId: "",         
        isActive: true,
        isDeleted: false
    },
  }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
        search(value){
       const route= {
        search: this.$route.search
      }
       if ((this.search)){      
        route.query = {search: this.search}        
      }
      this.$router.push(route)      
    
    },
    '$route.query':{
      immediate: true,
      async handler(value){
        this.locationTypes= await this.searchLocationTypes(value)
      }
    },
     '$route.query.search':{
      immediate: true,
      handler(value){
        this.search=value
      },
    }, 
  },
  created() {
    this.initialize();
  },
  methods: {
     searchLocationTypes(search){       
    this.isloading=true
      if(search.search!==""){      
        Api()
        .get('/locationTypes',{
          params: {
          search: search.search,
         }
          })
        .then(response=>{
          this.locationTypes=response.data          
    this.isloading=false
        })} 
      },
    fetchLocationTypes() {
        this.isloading=true
      Api()
        .get("/locationTypes/active")
        .then(response => {
          this.locationTypes = response.data;
          this.isloading=false
        });
      
    },
    fetchLocationTypeCats() {
      Api()
        .get("/locationTypeCats/active")
        .then(response => {
          this.locationTypeCat = response.data;
        });
    },
     initialize() {
      this.fetchLocationTypes();
      this.fetchLocationTypeCats();
    },
    editItem(item) {
      this.editedIndex = this.locationTypes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(id) {
     
      confirm("Are you sure you want to delete this item?") &&
        
      Api().put("/locationTypes/" + id, {
          isActive: false,
          isDeleted: true
        }).then(response => {
        this.fetchLocationTypes()
        })
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
        let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
      if (proceed == true) {
        Api().put("/locationTypes/" + this.editedItem.id, {
          name: this.editedItem.name,
          code: this.editedItem.code,
          // locationTypeCatId: this.editedItem.locationTypeCatId, 
          isDeleted: this.editedItem.isDeleted,          
          isActive: this.editedItem.isActive
        }).then(response => {
        this.fetchLocationTypes()
        })
        this.close();
        Object.assign(this.locationTypes[this.editedIndex], this.editedItem);
      }
      },
      saveNew() {
          let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
      if (proceed == true) {
        Api().post("/locationTypes", {
          name: this.editedItem.name,
          code: this.editedItem.code,
          // locationTypeCatId: this.editedItem.locationTypeCatId, 
          isDeleted: this.editedItem.isDeleted,          
          isActive: this.editedItem.isActive     
        }).then(response => {
        this.fetchLocationTypes()
        })
        this.close();
    }
      }
  }
};
</script>